<template>
  <div>
    <v-row v-if="isFiltersByUsers">
      <v-col cols="12">
        <gg-card>
          <gg-card-header>
            Filters by Users
          </gg-card-header>
          <gg-card-text>
            <filters-table />
          </gg-card-text>
        </gg-card>
      </v-col>
    </v-row>
    <transition name="router-anim" :enter-active-class="`animated ${routerAnimation}`">
      <router-view v-if="!isFiltersByUsers"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FiltersTable from '@/components/Services/Hosting/Shared/Email/UserFilters/Table'

export default {
  name: 'FiltersView',
  components: {
    FiltersTable
  },
  computed: {
    ...mapGetters(['routerAnimation']),
    isFiltersByUsers () {
      return this.$route.name === 'hosting_email_filters'
    }
  }
}
</script>
